import { action } from './index';

export const SET_BALANCE = 'USER/SET_BALANCE';
export const setBalance = (balance, balanceCash) =>
  action(SET_BALANCE, { balance, balanceCash });

export const SET_PROFILE = 'USER/SET_PROFILE';
export const setProfile = (profile) => action(SET_PROFILE, { profile });

export const SET_GUEST = 'USER/SET_GUEST';
export const setGuest = () => action(SET_GUEST);

export const SET_WALLETS = 'USER/SET_WALLETS';
export const setWallets = (wallets) => action(SET_WALLETS, { wallets });



// WEBPACK FOOTER //
// ./app/actions/userActions.js